var _excluded = ["url", "uuid", "uid", "path", "fps_list", "user_track", "values"];
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file 收集页面的 fps (Frame per second)
 * @author <caierwei@baijia.com>
 * @module module/fps
 */
/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import configurable from './util/configurable';
import request from './util/request';
import throttle from './util/throttle';
import onRouteChange from './util/onRouteChange';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';
import { trackID, getUserID, Config } from './util/config';
import { camelToUnder } from './util/json';
import { on, off } from './util/dom';
import getPath from './util/getPath';
var win = typeof window !== 'undefined' && window;
var doc = win && document;
var rAF = win.requestAnimationFrame || function raf(callback) {
  win.setTimeout(callback, 1000 / 60);
};
var cAF = win.cancelAnimationFrame || function caf(id) {
  win.clearTimeout(id);
};

// 当前浏览器支持的 hidden 和 visibilityChange 写法
var _ref = [['hidden', 'visibilitychange'], ['webkitHidden', 'webkitvisibilitychange'], ['mozHidden', 'mozvisibilitychange'], ['msHidden', 'msvisibilitychange']].filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return key in (doc || {});
  })[0] || [],
  _ref2 = _slicedToArray(_ref, 2),
  hidden = _ref2[0],
  visibilityChange = _ref2[1];

/**
 * 卡顿阈值，默认 20
 *
 * @const {number}
 */
var JANK_FPS = 20;

/**
 * 卡顿事件上报 fps 触发数，默认为 fps 连续 3 次低于 20 即触发上报事件
 *
 * @const {number}
 */
var JANK_COUNT = 3;

/**
 * 用户行为跟踪最大量
 *
 * @const {number}
 */
var USER_TRACK_QUEUE_LIMIT = 10;

/**
 * 两帧之间间隔时长最大限制
 *
 * @const {number}
 */
var INTERVAL_TIME_LIMIT = 116;

/**
  * fps性能上报
  *
  * @function
  * @param {Object} json 要上报的数据
  * @param {Function=} callback 上报后的回调
  */
var report = configurable(function (json, callback) {
  var _camelToUnder = camelToUnder(json),
    _camelToUnder$url = _camelToUnder.url,
    url = _camelToUnder$url === void 0 ? location.href : _camelToUnder$url,
    _camelToUnder$uuid = _camelToUnder.uuid,
    uuid = _camelToUnder$uuid === void 0 ? trackID : _camelToUnder$uuid,
    _camelToUnder$uid = _camelToUnder.uid,
    uid = _camelToUnder$uid === void 0 ? getUserID() : _camelToUnder$uid,
    _camelToUnder$path = _camelToUnder.path,
    path = _camelToUnder$path === void 0 ? getPath() : _camelToUnder$path,
    _camelToUnder$fps_lis = _camelToUnder.fps_list,
    fps_list = _camelToUnder$fps_lis === void 0 ? [] : _camelToUnder$fps_lis,
    _camelToUnder$user_tr = _camelToUnder.user_track,
    user_track = _camelToUnder$user_tr === void 0 ? [] : _camelToUnder$user_tr,
    _camelToUnder$values = _camelToUnder.values,
    values = _camelToUnder$values === void 0 ? {} : _camelToUnder$values,
    rest = _objectWithoutProperties(_camelToUnder, _excluded);

  // 要上报的数据
  var repData = _objectSpread({
    // 当前页面 URL
    url: url,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: uuid,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: uid,
    // 定义的当前页面路径，以区分多个页面
    path: path,
    fps_list: JSON.stringify(fps_list),
    user_track: JSON.stringify(user_track),
    values: JSON.stringify(values)
  }, rest);
  warnForbiddenKeys(repData);
  metric(_objectSpread(_objectSpread({}, repData), {}, {
    metric: 'fps'
  }));
  request(Config.VERB)("".concat(Config.PERF), repData, callback);
}, {});
var UserTrackQueue = /*#__PURE__*/function () {
  function UserTrackQueue() {
    _classCallCheck(this, UserTrackQueue);
    _defineProperty(this, "queues", []);
    _defineProperty(this, "limit", USER_TRACK_QUEUE_LIMIT);
  }
  _createClass(UserTrackQueue, [{
    key: "getQueues",
    value:
    /**
     * 获取户行为信息
     *
     * @function getQueues
     * @param {number} 取值
     * @return {Array} 返回用户行为信息
     */
    function getQueues() {
      var len = arguments.length > 0 && void 0 !== (arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 0 ? undefined : arguments[0] : 0;
      len = Math.abs(len) > this.queues.length ? 0 : len;
      return this.queues.slice(len);
    }

    /**
     * 收集用行为信息
     *
     * @function addQueues
     * @param {Object} info 用户行为
     */
  }, {
    key: "addQueues",
    value: function addQueues(info) {
      info && Object.keys(info).length >= 1 && this.queues.push(info);
      if (this.getLength() > this.limit) {
        this.queues.shift();
      }
    }

    /**
     * 获取队列长度
     *
     * @function getLength
     * @return {number} 返回队列长度
     */
  }, {
    key: "getLength",
    value: function getLength() {
      return this.queues.length;
    }

    /**
     * 获取用户点击路径
     *
     * @function getUserClickTrack
     * @param {Event} click 事件 event
     * @return {Object} 返回路径信息
     */
  }, {
    key: "getUserClickTrack",
    value: function getUserClickTrack(e) {
      if (!e) {
        return {};
      }
      var trackInfo = {};
      var node = e.target || e.srcElement;
      trackInfo.tn = node.tagName ? node.tagName.toLowerCase() : '';
      trackInfo.nt = node.nodeType || 0;
      trackInfo.xp = this.getElePath(node);
      trackInfo.id = node.id || '';
      trackInfo.cn = node.className || '';
      trackInfo.url = location.href;
      trackInfo.tm = Date.now();
      trackInfo.type = 'click';
      trackInfo.pos = function pos(e) {
        var t = {};
        var left = e.offsetLeft || 0;
        var top = e.offsetTop || 0;
        var parent = e.offsetParent;
        while (parent) {
          left += parent.offsetLeft || 0;
          top += parent.offsetTop || 0;
          parent = parent.offsetParent;
        }
        t.x = left;
        t.y = top;
        return t;
      }(node);
      return trackInfo;
    }
  }, {
    key: "getElePath",
    value: function getElePath(node) {
      if (!(node instanceof Element)) {
        return '';
      }
      if (node.id) {
        return "id(\"".concat(node.id, "\")");
      }
      if (node === document.body) {
        return node.tagName.toLowerCase();
      }
      var node_nth = 0;
      var childNodes = node.parentNode && node.parentNode.childNodes || [];
      for (var i = 0, len = childNodes.length; i < len; i++) {
        var curNode = childNodes[i];
        if (curNode === node) {
          return "".concat(this.getElePath(node.parentNode), "/").concat(node.tagName.toLowerCase(), "[").concat(node_nth + 1, "]");
        }
        1 === curNode.nodeType && curNode.tagName === node.tagName && node_nth++;
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!UserTrackQueue.instance) {
        UserTrackQueue.instance = new UserTrackQueue();
      }
      return UserTrackQueue.instance;
    }
  }]);
  return UserTrackQueue;
}();
var FPSMonitor = /*#__PURE__*/function () {
  // 上一秒时间

  // 上一帧的时间

  // 1s 执行了多少帧

  // 两帧之间间隔超过 116ms 的队列

  function FPSMonitor() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, FPSMonitor);
    _defineProperty(this, "timerId", null);
    _defineProperty(this, "lastTime", null);
    _defineProperty(this, "lastFrameTime", null);
    _defineProperty(this, "frame", 0);
    _defineProperty(this, "fpsQueue", []);
    _defineProperty(this, "intervalTimeQueue", []);
    _defineProperty(this, "config", {
      jank_fps: JANK_FPS,
      jank_count: JANK_COUNT,
      jank_interval_time: INTERVAL_TIME_LIMIT
    });
    _defineProperty(this, "lastTime", null);
    _defineProperty(this, "lastFrameTime", null);
    _defineProperty(this, "frame", 0);
    _defineProperty(this, "fpsQueue", []);
    _defineProperty(this, "intervalTimeQueue", []);
    _defineProperty(this, "timerId", null);
    this.config = _objectSpread(_objectSpread({}, this.config), args);
  }

  /**
   * 获取 FPSMonitor 实例
   *
   * @function getInstance
   * @param {?Object=} [ {jank_fps: 30, jank_count: 3} ] 自定义配置值
   * @return {Object} 返回 fpsMonitor 实例
   */
  _createClass(FPSMonitor, [{
    key: "isLowFPS",
    value:
    /**
     * 判断是否是低帧
     *
     * @function isLowFPS
     * @param {Array} fpsList 采集的 FPS 值
     * @param {number} below 卡顿的阀值限定值
     * @param {number} number 低于 below 多少次
     * @return {boolean} 返回是否是低帧
     */
    function isLowFPS(fpsList) {
      var below = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
      var count = 0;
      for (var i = 0, len = fpsList.length; i < len; i++) {
        var _fpsList$i;
        if (((_fpsList$i = fpsList[i]) === null || _fpsList$i === void 0 ? void 0 : _fpsList$i.fps) < below) {
          count++;
        } else {
          count = 0;
        }
        if (count >= number) {
          return true;
        }
      }
      return false;
    }

    // 上一秒时间
  }, {
    key: "resetCalculateVar",
    value:
    /**
     * 重置计算变量
     */
    function resetCalculateVar() {
      this.lastTime = null;
      this.lastFrameTime = null;
      this.frame = 0;
      this.fpsQueue = [];
      this.intervalTimeQueue = [];
    }

    /**
     * 计算帧率
     *
     * @function calculateFps
     */
  }, {
    key: "calculateFps",
    value: function calculateFps() {
      var that = this;
      function fpsStep(now) {
        var _that$lastTime, _that$lastFrameTime;
        // const now = Date.now();
        that.lastTime = (_that$lastTime = that.lastTime) !== null && _that$lastTime !== void 0 ? _that$lastTime : now;
        that.lastFrameTime = (_that$lastFrameTime = that.lastFrameTime) !== null && _that$lastFrameTime !== void 0 ? _that$lastFrameTime : now;
        var interval_time = now - that.lastFrameTime;
        that.lastFrameTime = now;
        var fps = interval_time > 0 ? Math.round(1000 / interval_time) : 0;
        if (interval_time >= that.config.jank_interval_time) {
          that.intervalTimeQueue.push({
            time: Date.now(),
            fps: fps,
            // 卡顿时长
            jank_time: interval_time
          });
        } else {
          if (that.intervalTimeQueue.length) {
            var userTrack = UserTrackQueue.getInstance().getQueues(-5);
            var intervalTimeQueueLen = that.intervalTimeQueue.length;
            var fps_avg = that.intervalTimeQueue.reduce(function (sum) {
              var intervalTimeItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              sum = sum + intervalTimeItem.fps;
              return sum;
            }, 0) / intervalTimeQueueLen;
            var time_total = that.intervalTimeQueue.reduce(function (sum) {
              var intervalTimeItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              sum = sum + intervalTimeItem.jank_time;
              return sum;
            }, 0);
            report({
              fpsList: that.intervalTimeQueue,
              userTrack: userTrack,
              values: {
                fps_avg: fps_avg,
                time_total: time_total,
                time_avg: time_total / intervalTimeQueueLen
              }
            });
            that.resetCalculateVar();
          }
          that.frame += 1;
          if (that.lastTime && now > 1000 + that.lastTime) {
            var _fps = Math.round(that.frame / ((now - that.lastTime) / 1000));
            // 不大于设置的 fps 就被认定为低帧率
            if (_fps <= that.config.jank_fps) {
              that.fpsQueue.push({
                time: Date.now(),
                fps: _fps
              });
            }
            // 不是低帧率了，就检查之前的低帧是否符合条件
            else if (that.isLowFPS(that.fpsQueue, that.config.jank_fps, that.config.jank_count)) {
              var _userTrack = UserTrackQueue.getInstance().getQueues(-5);
              var fpsQueueLen = that.fpsQueue.length;
              var total_fps = that.fpsQueue.reduce(function (sum) {
                var fpsItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                sum = sum + fpsItem.fps;
                return sum;
              }, 0);
              var _fps_avg = total_fps / fpsQueueLen;
              var _time_total = fpsQueueLen * 1000;
              report({
                fpsList: that.fpsQueue,
                userTrack: _userTrack,
                values: {
                  fps_avg: _fps_avg,
                  time_total: _time_total,
                  time_avg: _time_total / total_fps
                }
              });
              that.fpsQueue = [];
            } else {
              that.fpsQueue = [];
            }
            that.frame = 0;
            that.lastTime = now;
          }
        }
        that.timerId = rAF(fpsStep);
      }
      that.timerId = rAF(fpsStep);
    }

    /**
     * 开始帧率监控
     *
     * @function startMonitor
     */
  }, {
    key: "startMonitor",
    value: function startMonitor() {
      var _this = this;
      this.stopFpsStepRAF();
      this.resetCalculateVar();
      this.calculateFps();
      this.tearDown = onRouteChange(function (e) {
        var isTrusted = e.isTrusted,
          habo = e.habo;
        if (isTrusted || habo && !isTrusted) {
          _this.stopFpsStepRAF();
          _this.resetCalculateVar();
          _this.calculateFps();
        }
      });
    }

    /**
     *停止帧率监控
     *
     * @function stopMonitor
     */
  }, {
    key: "stopMonitor",
    value: function stopMonitor() {
      this.stopFpsStepRAF();
      if (typeof this.tearDown === 'function') {
        this.tearDown();
      }
      this.resetCalculateVar();
    }

    /**
     *停止帧率计算
     *
     * @function stopFpsStepRAF
     */
  }, {
    key: "stopFpsStepRAF",
    value: function stopFpsStepRAF() {
      if (this.timerId) {
        cAF(this.timerId);
        this.timerId = null;
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!FPSMonitor.instance) {
        FPSMonitor.instance = new FPSMonitor(_objectSpread({}, conf));
      }
      return FPSMonitor.instance;
    }
  }]);
  return FPSMonitor;
}();
var observeClick = throttle(function (e) {
  var trackInfo = UserTrackQueue.getInstance().getUserClickTrack(e);
  UserTrackQueue.getInstance().addQueues(trackInfo);
}, 300);
var monitorFps = function monitorFps() {
  if (doc[hidden]) {
    FPSMonitor.getInstance().stopMonitor();
  } else {
    FPSMonitor.getInstance().startMonitor();
  }
};

/**
 * 解除相关事件的绑定
*/
function destroy() {
  FPSMonitor.getInstance().stopMonitor();
  off(doc, 'click', observeClick, true);
  off(win, 'unload', destroy);
  off(doc, visibilityChange, monitorFps);
}
report.init = function () {
  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  FPSMonitor.getInstance(conf).startMonitor();
  on(doc, 'click', observeClick, true);
  on(win, 'unload', destroy);
  on(doc, visibilityChange, monitorFps);
};
export default report;